import React from 'react';

import {SquareGrid} from '@homeaway/landing-presentational';

import {handleClick} from '../events';
import {buildImageUrl, BASE_CLASS} from '../constants';
import {selector} from '../../../utils/wdio-selectors';

const DynamicDestinationRefinementsMobile = ({lbsId, heading, cards}) => {
    const items = cards.map((card) => ({
        href: card.slpUrl || card.serpUrl,
        rel: card.noFollowHref,
        label: card.heading,
        imageSrc: buildImageUrl(card.imageUrl),
        filterId: card.filterId,
    }));

    const mkClickHandler = (item, idx) =>
        handleClick({lbsId, position: idx, filterId: item.filterId});

    return (
        <div
            className={`${BASE_CLASS} container module`}
            data-wdio={selector.dynamicRefinements}
        >
            <h2>{heading}</h2>
            <SquareGrid items={items} onClick={mkClickHandler} />
        </div>
    );
};

DynamicDestinationRefinementsMobile.displayName =
    'DynamicDestinationRefinementsMobile';

export default DynamicDestinationRefinementsMobile;
